import { memo } from 'react';
import {
  Alert,
  Box,
  Button,
  ButtonDropdown,
  ButtonDropdownProps,
  FormField,
  Modal,
  SpaceBetween,
} from '@amzn/awsui-components-core';

import UserIdAutosuggest from '../common/UserIdAutosuggest';
import { useAuthorActionsViewModel } from './AuthorActionsViewModel';

const MAKE_UPDATES_ID = 'make-updates';
const ADD_CO_AUTHOR_ID = 'add-co-author';

const ACTION_ITEMS: ButtonDropdownProps.Items = [
  { id: MAKE_UPDATES_ID, text: 'Make updates' },
  { id: ADD_CO_AUTHOR_ID, text: 'Add co-author' },
];

/** Author "Actions" dropdown for the Update Requests tab: make updates and add co-author. */
export const AuthorActionsView = memo(function AuthorActionsView() {
  const vm = useAuthorActionsViewModel();

  if (!vm || !vm.isVisible) return null;

  return (
    <>
      <SpaceBetween size="xs">
        {vm.actionError && (
          <Alert type="error" dismissible onDismiss={vm.dismissActionError}>
            {vm.actionError}
          </Alert>
        )}
        <ButtonDropdown
          items={ACTION_ITEMS}
          loading={vm.isProcessingAction}
          onItemClick={({ detail }) => {
            if (detail.id === MAKE_UPDATES_ID) vm.makeUpdates();
            if (detail.id === ADD_CO_AUTHOR_ID) vm.openCoAuthorModal();
          }}
        >
          Actions
        </ButtonDropdown>
      </SpaceBetween>

      {vm.isCoAuthorModalOpen && (
        <Modal
          visible
          header="Add co-author"
          onDismiss={vm.closeCoAuthorModal}
          closeAriaLabel="Close modal"
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={vm.closeCoAuthorModal}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={vm.addCoAuthor}
                  loading={vm.isAddingCoAuthor}
                  disabled={!vm.isCoAuthorValid}
                >
                  Add co-author
                </Button>
              </SpaceBetween>
            </Box>
          }
        >
          <SpaceBetween size="m">
            <FormField label="Co-author">
              <UserIdAutosuggest
                isRequired={false}
                onUserSelected={(
                  userId: string | undefined,
                  userName: string | undefined,
                  validationError: string | undefined,
                ) => vm.selectCoAuthor(userId ?? '', userName ?? '', validationError ?? '')}
              />
            </FormField>
            {vm.coAuthorError && <Alert type="warning">{vm.coAuthorError}</Alert>}
          </SpaceBetween>
        </Modal>
      )}
    </>
  );
});
